<template>
  <div class="row">
    <div v-if="!nalaganje">
      <div class="col-md-4 col-sm-6 col-xs-12">
        <div class="info-box">
          <span v-if="points/maxPoints > 0.75" class="info-box-icon bg-gray-light"><i class="glyphicon glyphicon-ok" style="color: #0073b7"></i></span>
          <span v-else class="info-box-icon bg-gray-light"><i class="glyphicon glyphicon-ok" style="color: #f39c12"></i></span>
          <!--
          <span class="info-box-icon bg-green" v-if="points/maxPoints > 0.75"><i class="glyphicon glyphicon-ok"></i></span>
          <span class="info-box-icon bg-yellow" v-else><i class="glyphicon glyphicon-ok"></i></span>
          -->

          <div class="info-box-content">
            <span class="info-box-text">{{$t("pages.exams.ratingResults.achievvedPoints")}}</span>
            <span class="info-box-number" style="font-size: 30px">{{points}}/{{maxPoints}}</span>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-12">
        <div class="info-box">
          <span class="info-box-icon bg-gray-light"><i class="glyphicon glyphicon-stats" style="color: #0073b7"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">{{$t("pages.exams.ratingResults.ratingChange")}}</span>
            <span class="info-box-number" style="font-size: 30px">{{oldRating}} <i class="fa fa-arrow-right" ></i> {{newRating}}</span>
          </div>

        </div>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-12">
        <div class="info-box">
          <span v-if="newRatingDeviation <= 70" class="info-box-icon bg-gray-light"><i class="fa fa-bullseye" style="color: #0073b7"></i></span>
          <span v-else-if="newRatingDeviation <= 180" class="info-box-icon bg-gray-light"><i class="fa fa-bullseye" style="color: #f39c12"></i></span>
          <span v-else class="info-box-icon bg-gray-light"><i class="fa fa-bullseye" style="color: #dd4b39"></i></span>


          <div class="info-box-content">
            <span class="info-box-text">{{$t("pages.exams.ratingResults.ratingAccuracy")}}</span>

            <span class="info-box-number" style="font-size: 30px">{{Math.round((1 - oldRatingDeviation/350) * 100)}} <i class="fa fa-arrow-right"></i> {{Math.round((1 - newRatingDeviation/350) * 100)}}%</span>
          </div>

        </div>
      </div>

      <div class="col-md-4 col-xs-12 clickable">
        <div class="box">
          <div class="box-header with-border">
            <h3 class="box-title">{{$t("pages.exams.ratingResults.viewYourAnswers")}}</h3>

            <div class="box-tools pull-right">
              <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip"
                      title="Collapse">
                <i class="fa fa-minus"></i></button>
            </div>
          </div>
          <div class="info-box" @click.prevent="showQuestions">
            <div class="info-box">
              <span class="info-box-icon bg-gray-light"><i class="fa fa-list-ul"></i></span>

              <div class="info-box-content">
                <span class="info-box-number" style="font-size: 25px">{{$t("pages.exams.ratingResults.viewYourAnswers")}}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
          </div>
          <!-- /.box-body -->
        </div>
      </div>
      <div v-if="!toggleLeaderboard" class="col-md-8 col-xs-12">
        <div class="box">
          <div class="box-header with-border">
            <h3 class="box-title">Ranking</h3>

            <div class="box-tools pull-right">
              <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip"
                      title="Collapse">
                <i class="fa fa-minus"></i></button>
            </div>
          </div>

          <div class="info-box">
            <span v-if="!toggleLeaderboard" class="info-box-icon bg-blue"><i class="fa fa-trophy"></i></span>
            <span v-else class="info-box-icon bg-green"><i class="fa fa-trophy"></i></span>

            <div class="info-box-content">
              <span class="info-box-text"></span>
              <span v-if="!toggleLeaderboard" class="info-box-number">{{$t("pages.exams.ratingResults.completeMoreQuizes")}}</span>
              <span v-else class="info-box-number">{{$t("pages.exams.ratingResults.joinedLeaderboard")}}</span>
              <div v-if="!toggleLeaderboard" class="progress-leaderboard">
                <div class="progress-bar-eighty"></div>
                <div class="progress-bar-leaderboard" :style="'width: ' + (1-latestRatingDeviation/350)*100 + '%; background: #0073b7'"></div>
              </div>
              <span v-if="!toggleLeaderboard" class="progress-description">{{$t("pages.exams.ratingResults.yourRatingIsInaccurate")}} <b>75%</b></span>
              <span v-else class="progress-description">{{$t("pages.exams.ratingResults.improveRating")}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 col-xs-12">
        <div class="box">
          <div class="box-header with-border">
            <h3 class="box-title">{{$t("pages.exams.ratingResults.leaderboard")}}</h3>

            <div class="box-tools pull-right">
              <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip"
                      title="Collapse">
                <i class="fa fa-minus"></i></button>
            </div>
          </div>

          <div v-if="leaderboard.length > 0" id="leaderboard">
            <div class="ribbon"></div>
            <table>
              <tr v-for="(user, index) in leaderboard.slice(0, 6)" :key="user.username">
                <td v-if="user.place" class="number">{{user.place + 1}}</td>
                <td v-else class="number">{{index + 1}}</td>
                <td v-if="user.place" class="name" style="font-weight: bold; color: #00a65a; ">{{user.username}}</td>
                <td v-else class="name">{{user.username}}</td>
                <td v-if="user.place" class="points" >{{user.ratingGlicko}}</td>
                <td v-else class="points">
                  {{user.ratingGlicko}}
                  <img v-if="index == 0" class="gold-medal" src="https://github.com/malunaridev/Challenges-iCodeThis/blob/master/4-leaderboard/assets/gold-medal.png?raw=true" alt="gold medal"/>
                </td>
              </tr>
            </table>
          </div>
          <div v-else>
            <div style="padding: 20px; text-align: center;">
              <span>{{$t('pages.exams.ratingResults.leaderboardEmpty')}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 col-xs-12">
        <div class="box">
          <div class="box-header with-border">
            <h3 class="box-title">{{$t("pages.exams.ratingResults.ratingHistory")}}</h3>

            <div class="box-tools pull-right">
              <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip"
                      title="Collapse">
                <i class="fa fa-minus"></i></button>
            </div>
          </div>
          <div class="box-body">
            <line-chart class="" :height="125" :options="{ scales: { yAxes: [{ ticks: {max: max, min: min} }] } }" :chartData="zgodovinaRatinga"></line-chart>
          </div>
          <!-- /.box-body -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Rest from './../../services/rest'
  import Line from '@/charts/Line.js'

  export default {
    components: {
      'line-chart': Line
    },
    props: {
      attemptId: '',
      gid: '',
      yid: '',
      sid: ''
    },
    data () {
      return {
        nalaganje: true,
        oldRating: -1,
        newRating: -1,
        oldRatingDeviation: -1,
        newRatingDeviation: -1,
        latestRatingDeviation: -1,
        points: -1,
        maxPoints: -1,
        ratingHistory: null,
        zgodovinaRatinga: null,
        timeAxis: null,
        min: 0,
        max: 200,
        currentUser: null,
        leaderboard: [],
        toggleLeaderboard: true
      }
    },
    name: 'RatingExamResults',
    mounted () {
      this.$store.dispatch('getGroup', {
        gid: this.gid,
        yid: this.yid,
        sid: 'root'
      })
      this.$store.commit('updateAdminBreadcrumbs', [{path: '', name: {'en-us': 'Results', sl: 'Rezultati'}}])
      this.getRatingData()
    },
    methods: {
      pripraviGraf () {
        let data = []
        this.timeAxis = []
        for (let i = this.ratingHistory.length - 1; i >= 0; i--) {
          data.push(this.ratingHistory[i].ratingGlicko)
          this.timeAxis.push(i + 1)
        }
        this.zgodovinaRatinga = {labels: this.timeAxis, datasets: [{label: this.$t('pages.exams.ratingResults.rating'), fill: false, borderColor: '#2872ca', data: data}]}
        this.min = Math.min.apply(null, data) - 10
        this.max = Math.max.apply(null, data) + 10
      },
      showQuestions () {
        this.$router.push({name: 'classExamResults', params: {classExamId: this.attemptId}})
      },
      getRatingData () {
        let postdata = {
          attemptId: this.attemptId,
          groupId: this.gid
        }
        return Rest.request('POST', `/rating/ratingQuizResults`, postdata).then((data) => {
          this.oldRating = data.oldRating
          this.newRating = data.newRating
          this.oldRatingDeviation = data.oldRatingDeviation
          this.newRatingDeviation = data.newRatingDeviation
          this.points = data.points
          this.maxPoints = data.maxPoints
          this.ratingHistory = data.ratingHistory
          this.pripraviGraf()
          this.pripraviGraf(data.ratingHistory)
          this.showLeaderboard()
        }).catch((err) => {
          console.log(err)
          this.nalaganje = false
        })
      },
      showLeaderboard () {
        Rest.request('GET', '/rating/leaderboard/' + this.gid).then((data) => {
          this.leaderboard = data.userRatings
          this.currentUser = this.$store.getters.getUser
          let index = this.leaderboard.map(function (e) {
            return e.username
          }).indexOf(this.currentUser.username)

          if (index === -1) {
            this.toggleLeaderboard = false
          } else if (index > 5) {
            this.leaderboard[5] = this.leaderboard[index]
            this.leaderboard[5].place = index
          }

          this.latestRatingDeviation = this.ratingHistory[0].ratingDeviation
          this.nalaganje = false
        })
      }
    }
  }
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
#header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2.5rem 2rem;
}

h1 {
  font-family: "Rubik", sans-serif;
  font-size: 1.7rem;
  color: #141a39;
  text-transform: uppercase;
  cursor: default;
}
#leaderboard-overlay {
  height: 20rem;
  width: 100%;
  top: 0;
  background-color: rgba(255, 255, 255, 0.9);
}
#leaderboard {
  margin-top: 5px;
  width: 100%;
  position: relative;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  color: #141a39;
  cursor: default;
}

tr {
  transition: all 0.2s ease-in-out;
  border-radius: 0.2rem;
}

tr:not(:first-child):hover {
  background-color: #fff;
  transform: scale(1.0);
  box-shadow: 0px 5px 15px 8px #e4e7fb;
}

tr:nth-child(odd) {
  background-color: #f9f9f9;
}

tr:nth-child(1) {
  color: #fff;
}

td {
  height: 5rem;
  font-family: "Rubik", sans-serif;
  font-size: 1.4rem;
  padding: 1rem 2rem;
  position: relative;
}

.number {
  width: 1rem;
  font-size: 2.2rem;
  font-weight: bold;
  text-align: left;
}

.name {
  text-align: left;
  font-size: 1.2rem;
}

.points {
  font-weight: bold;
  font-size: 1.3rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 5.2rem;
}

.points:first-child {
  width: 10rem;
}

.gold-medal {
  height: 3rem;
  width: 3rem;
  margin-left: 1.5rem;
  margin-right: 0;
}

.ribbon {
  width: calc(100% + 1rem);
  height: 5.5rem;
  top: -0.5rem;
  background-color: #0073b7;
  position: absolute;
  left: -0.5rem;
  -webkit-box-shadow: 0px 15px 11px -6px #7a7a7d;
  box-shadow: 0px 10px 11px -6px #a6a6a9;
}

.ribbon::before {
  content: "";
  height: 1.5rem;
  width: 1.5rem;
  bottom: -0.8rem;
  left: 0.35rem;
  transform: rotate(45deg);
  background-color: #0073b7;
  position: absolute;
  z-index: -1;
}

.ribbon::after {
  content: "";
  height: 1.5rem;
  width: 1.5rem;
  bottom: -0.8rem;
  right: 0.35rem;
  transform: rotate(45deg);
  background-color: #0073b7;
  position: absolute;
  z-index: -1;
}

@media (max-width: 740px) {
  * {
    font-size: 70%;
  }
}
@media (max-width: 500px) {
  * {
    font-size: 55%;
  }
}
@media (max-width: 390px) {
  * {
    font-size: 45%;
  }
}
.progress-leaderboard {
  position: relative;
  margin: 13px 0 7px 0;
  width: 100%;
  height: 1rem;
  background-color: #f5f5f5;
}
.progress-bar-leaderboard {
  height: 100%;
  position: absolute;
  top: 0rem;
  left: 0rem;
  background-color: #0073b7;
}
.progress-bar-eighty {
  height: 1rem;
  left: 0;
  width: 75%;
  background-color: #d0d0d0;
}
</style>


// WEBPACK FOOTER //
// RatingExamResults.vue?13d50d90